import React from 'react'
import Button from '.'
import styles from './styles.module.css'

const ButtonInternalLink = ({ children, onClick, type = 'default', ...props }) => {
  const styleMap = {
    default: styles.buttonDefault,
    primary: styles.button,
  }

  return (
    <Button onClick={onClick} className={`${styles.button} ${styleMap[type]} ${styles.buttonInternalLink}`} {...props}>
      {children}
    </Button>
  )
}

export default ButtonInternalLink
